/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useRef, useEffect } from "react";
import ButtonBlue from "../../components/Button/ButtonBlue";
import Button from "../../components/Button/Button";
import ActionButton from "../../components/Button/ActionButton";
import Cancel from "../../common/images/cancel.png";
import "../../styles/shared.styles.scss";
import SharePostCard from "../Community/SharePostCard";
import { useHistory, useLocation } from "react-router-dom";
import { ButtonCommonTop, ButtonCommonTopNew, Card, DivBadge } from "../Theme";
import { AiOutlineCloseCircle } from "react-icons/ai";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { useSelector } from "react-redux";
import CROSS_BLACK_ICON from "@mui/icons-material/Clear";
import { Progress } from "react-sweet-progress";
import "react-sweet-progress/lib/style.css";
import axios from "axios";
import { apiUrl, serverUrl } from "../../components/Helpers/Config";
import { tokenAuthorize } from "../../components/Helpers/Common";
import NavTabs from "../../components/Navbar/NavTabs";
import SearchBar from "../../components/Searchbar";
const tabs = [
  { text: "Select Existing Post", id: 1 },
  { text: "Upload File(s)", id: 2 },
];

const ModalRespondTask = ({
  show,
  handleClose,
  posts,
  attachPost,
  selectedPost,
  setSelectedPost,
  taskId,
}) => {
  // (selectedPost)
  const location = useLocation();
  const history = useHistory();
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);

  const [currentPage, setCurrentPage] = useState(1);
  const uploaderRef = useRef();
  const [files, setFiles] = useState([]);
  const [post, setPost] = useState({
    title: "",
    cover: "",
    tags: [],
    courses: [],
    events: [],
    values: [],
    location: { label: "", value: "" },
    attachments: [],
  });
  //Attachments Limitations
  const [attachmentExtension, setAttachmentExtension] = useState(null);
  const [attachmentFileSize, setAttachmentFileSize] = useState(null);
  const [errorFileSizeLimits, setErrorFileSizeLimits] = useState([]);
  const [errorFileNotExtention, setErrorFileNotExtention] = useState([]);
  const modalRef = useRef();
  const [showErrorFiles, setShow] = useState(false);
  useEffect(() => {
    //Attachment Limitations
    getAttachmentLimitations();
  }, []);
  const getAttachmentLimitations = () => {
    axios
      .get(serverUrl.AttachmentsLimit)
      .then((resp) => {
        if (resp.status === 200) {
          setAttachmentExtension(
            resp?.data?.results?.attachment_types.length != 0
              ? resp?.data?.results?.attachment_types.join(",")
              : null
          );
          setAttachmentFileSize(
            resp?.data?.results?.attachment_size
              ? resp?.data?.results?.attachment_size
              : null
          );
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
      });
  };
  // useEffect(() => {
  //     if (show == true){
  //         setCurrentPage(1)
  //         setSelectedPost([])
  //         setFiles([])
  //     }
  // }, [])

  function addItem(id) {
    const newList = [
      ...selectedPost,
      ...posts.filter((item) => item.reflection_id === id),
    ];
    setSelectedPost(newList);
  }

  function removeItem(id) {
    const newList = selectedPost.filter((item) => item.reflection_id !== id);
    setSelectedPost(newList);
  }

  const [searchField, setSearchField] = useState("");

  const searchedPost = posts.filter((post) =>
    post.reflection_title.toLowerCase().includes(searchField.toLowerCase())
  );

  const handleAttachPost = () => {
    if (currentPage == 1) {
      setSelectedPost(selectedPost);
      attachPost([]);
    }
    if (currentPage == 2) {
      // (selectedPost1)
      // setSelectedPost1(selectedPost1)
      attachPost(files);
      //setFiles([])
    }
  };

  function switchTab(id) {
    if (currentPage !== id) {
      setSelectedPost([]);
      setFiles([]);
      setCurrentPage(id);
      if (id === 2) {
        getAttachmentLimitations();
      }
    }
    // setCheckedList([])
  }

  const addFiles = (e) => {
    let fileList = [],
      fileNames = [],
      errorFiles = [];
    setErrorFileSizeLimits([]);
    setErrorFileNotExtention([]);
    const allowedExtensions = (attachmentExtension || "")
      .split(",")
      .map((ext) => ext.trim().toLowerCase())
      .filter(Boolean); // removes empty values
    const maxSizeMB = attachmentFileSize ?? Infinity;
    Array.from(e.currentTarget.files).forEach((file) => {
      //file size convert to check MB format
      const sizeInMB = file.size / (1024 * 1024);
      const fileExt = "." + file.name.split(".").pop().toLowerCase();

      const isSizeValid = sizeInMB <= maxSizeMB;
      const isExtValid =
        allowedExtensions.length === 0 || allowedExtensions.includes(fileExt);

      if (isSizeValid && isExtValid) {
        fileList.push(file);
        fileNames.push(file.name);
      } else {
        if (!isSizeValid) {
          setErrorFileSizeLimits((prev) => [...prev, file]);
        } else {
          setErrorFileNotExtention((prev) => [...prev, file]);
        }
        errorFiles.push(file);
      }
    });
    setFiles([...files, ...fileList]);
    if (errorFiles.length > 0) {
      setShow(true);
    }
  };

  const handleFileUpload = () => {
    uploaderRef.current.value = "";
    uploaderRef.current.click();
  };

  const handleModalClose = () => {
    setSelectedPost([]);
    setFiles([]);
    setCurrentPage(1);
    handleClose();
  };

  const handleRemoveFile = (id) => {
    setFiles(files.filter((_, index) => index !== id));
  };

  const Popup = () => {
    const style = `${showErrorFiles ? "flex" : "hidden"
      } fixed top-0 left-0 w-full h-full popUpWidth bg-black bg-opacity-60 z9999 justify-center items-center`;

    return (
      <div className={style} onClick={(e) => e.stopPropagation()}>
        <section className="z9999">
          <Card className="rounded-lg bg-white shadow-lg h-full max-h-screen overflow-hidden">
            {/* Header */}
            <div className="relative flex items-center justify-between px-5 py-3 border-b border-gray-200">
              <div className="font-bold text-base">Error Files</div>
              <CROSS_BLACK_ICON
                className="w-6 h-6 cursor-pointer hover:opacity-60"
                onClick={() => setShow(false)}
              />
            </div>

            {/* Scrollable content area */}
            <div className="overflow-y-auto px-3 py-4" ref={modalRef}>
              <div className="space-y-2">
                {errorFileNotExtention.length > 0 && (
                  <div>
                    <p className="text-sm px-2 text-justify">
                      The following files are not supported:
                    </p>
                    <ul className="list-disc list-inside text-red-500 text-sm px-5">
                      {errorFileNotExtention.map((file, index) => (
                        <li key={`ext-${index}`} className="py-1">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
                {errorFileSizeLimits.length > 0 && (
                  <div>
                    <p className="text-sm px-2 text-justify">
                      The following files exceed the size limit of{" "}
                      {attachmentFileSize} MB:
                    </p>
                    <ul className="list-disc list-inside text-red-500 text-sm px-5">
                      {errorFileSizeLimits.map((file, index) => (
                        <li key={`size-${index}`} className="py-1">
                          {file.name}
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </Card>
        </section>
      </div>
    );
  };

  const showHideModal = show
    ? "block fixed flex items-center justiify-center top-0 left-0 w-full h-full bg-black bg-opacity-60 z999"
    : "hidden";

  return (
    <div className={showHideModal}>
      <Popup />
      <section className="fixed inset-0 flex items-center justify-center z-50">
        <Card
          className="
      bg-white rounded-lg shadow-lg 
      w-full md:w-4/5 popUpWidth
      p-4 
    "
        >
          <div className="flex py-2 px-2 justify-between items-center">
            <div className="w-full font-semibold blackColor ">
              Respond options
            </div>
            <button
              className="text-gray-600 hover:text-black text-xl font-bold"
              onClick={handleModalClose}
            >
              ×
            </button>
          </div>
          <div className="cursor-pointer flex flex-row items-center justify-between  px-2">
            {/* {isDefaultTheme == true ? (
              <div
                className={`h-12 rounded-full-tab font-semibold
                                        font-semiboldflex flex 
                                        items-center justify-center bg-white
                                       bg-white text-black hover:opacity-70 border-gray-400 border-2 p-3`}
                onClick={() =>
                  history.push("/journal/new", {
                    src: location.pathname,
                    taskId: taskId,
                    data: "journal",
                  })
                }
              >
                {"Create New Post"}
              </div>
            ) : (
              <Button
                className={`h-12 rounded-full-tab font-semibold
                                            font-semiboldflex flex 
                                            items-center justify-center
                                           text-black hover:opacity-70 border-gray-400 border-2 p-3`}
                onClick={() =>
                  history.push("/journal/new", {
                    src: location.pathname,
                    taskId: taskId,
                    data: "journal",
                  })
                }
                title="Create New Post"
              ></Button>
            )} */}
            <NavTabs
              menuLinks={[
                {
                  title: "Select Existing Post",
                  index: 1,
                  onChange: (e) => {
                    switchTab(1);
                  },
                },
                {
                  title: "Upload File(s)",
                  index: 2,
                  onChange: (e) => {
                    switchTab(2);
                  },
                },
              ]}
              value={currentPage}
              padding={false}
              isDot={false}
            />
            <ButtonCommonTopNew
              onClick={() =>
                history.push("/journal/new", {
                  src: location.pathname,
                  taskId: taskId,
                  data: "journal",
                })
              }
              className="px-4 py-2 text-sm rounded-lg"
            >
              Create new post
            </ButtonCommonTopNew>
            {/* {tabs.map((tab, ind) =>
              isDefaultTheme == false ? (
                currentPage === tab.id ? (
                  <ButtonCommon
                    key={tab.id}
                    className={`h-12 rounded-full-tab font-semibold
                                            font-semiboldflex flex 
                                            items-center justify-center hover:opacity-70
                                        p-3 px-10 py-3`}
                    buttonStyle={ind == 0 ? "mx-5" : ""}
                    onClick={() => switchTab(tab.id)}
                    title={tab.text}
                  ></ButtonCommon>
                ) : (
                  <Button
                    key={tab.id}
                    className={`h-12 rounded-full-tab font-semibold
                                                                    font-semiboldflex flex 
                                                                    items-center justify-center
                                                                    hover:opacity-70 border-gray-400 border-2
                                         p-3 ml-5`}
                    onClick={() => switchTab(tab.id)}
                    title={tab.text}
                    style={ind == 0 ? "mx-5" : ""}
                  ></Button>
                )
              ) : (
                <div
                  key={tab.id}
                  className={`h-12 rounded-full-tab font-semibold
                                                font-semiboldflex flex 
                                                items-center justify-center bg-white
                                                ${
                                                  currentPage !== tab.id
                                                    ? `bg-white text-black hover:opacity-70 border-gray-400 border-2`
                                                    : `bg-blue text-white`
                                                  // : `bg-white text-black hover:opacity-70 border-gray-400 border-2`
                                                } ${`ml-5 `} p-3 `}
                  onClick={() => switchTab(tab.id)}
                >
                  {tab.text}
                </div>
              )
            )} */}
          </div>

          {/* {currentPage == 1 && <>
                        <div className="sharepost p-4 flex flex-col items-center justify-center gap-4 m-5 p-5">
                            <div className="flex w-20 md:w-full justify-center">
                                <ButtonBlue title="CREATE NEW POST" width="96" onClick={() => history.push("/journal/new", { src: location.pathname, taskId: taskId, data: "journal" })} />
                            </div>
                        </div></>} */}

          {currentPage == 1 && (
            <>
              <div className="sharepost p-4 px-2 flex flex-col items-center justify-center gap-4 mt-3">
                <div className="flex w-full items-center justify-start">
                  {/* <div className="w-max flex items-center font-bold whitespace-nowrap mr-3">
                    Select Post
                  </div> */}
                  {/* <input
                    type="textarea"
                    placeholder="search post here..."
                    className="w-44 h-10 pl-3 text-black md:pl-6 bg-gray-100 border-2 rounded-lg outline-none"
                    onChange={(e) => setSearchField(e.target.value)}
                  /> */}
                  <div className="flex items-center w-full md:w-1/4 justify-start">
                    <SearchBar
                      setSearchField={setSearchField}
                      placeholder="Search post here"
                    />
                  </div>
                </div>
                <div className="overflow-y-auto space-y-3">
                  {searchedPost.length !== 0 ? (
                    searchedPost.map((item, idx) => (
                      <div key={idx} className="mr-5">
                        <SharePostCard
                          item={item}
                          idx={idx}
                          add={addItem}
                          remove={removeItem}
                          selectedPost={selectedPost}
                          isShow={
                            selectedPost?.filter(
                              (r) => r.reflection_id == item.reflection_id
                            )?.length > 0
                              ? true
                              : false
                          }
                        />
                      </div>
                    ))
                  ) : (
                    <p>Post not found</p>
                  )}
                </div>
              </div>
              <div className="w-full flex justify-center pt-2">
                {/* {isDefaultTheme === false ? (
                  <ButtonCommon
                    className={
                      selectedPost?.length > 0
                        ? "px-10 py-3"
                        : "opacity-30 px-10 py-3"
                    }
                    noCursor={selectedPost?.length > 0 ? false : true}
                    // bgColor={selectedPost?.length > 0 ? "bg-blue" : "bg-gray-400 hover:bg-gray-500"}
                    title={"Attach Post"}
                    onClick={handleAttachPost}
                  ></ButtonCommon>
                ) : (
                  <ButtonBlue
                    noCursor={selectedPost?.length > 0 ? false : true}
                    bgColor={
                      selectedPost?.length > 0
                        ? "bg-blue"
                        : "bg-gray-400 hover:bg-gray-500"
                    }
                    title={"Attach Post"}
                    onClick={handleAttachPost}
                  />
                )} */}
                <ButtonCommonTopNew
                  className={`px-4 py-2 rounded-lg text-sm ${selectedPost?.length > 0
                      ? "cursor-pointer"
                      : "cursor-not-allowed"
                    } `}
                  onClick={
                    selectedPost?.length > 0 ? handleAttachPost : () => { }
                  }
                >
                  Attach post
                </ButtonCommonTopNew>
              </div>
            </>
          )}

          {currentPage == 2 && (
            <>
              <div className="pt-5 px-2">
                <div className="w-full flex  py-4">
                  {/* {isDefaultTheme == false ? (
                    <ButtonCommon
                      title={"Add File"}
                      className={"hover:opacity:50 px-10 py-3"}
                      onClick={() => handleFileUpload()}
                    ></ButtonCommon>
                  ) : (
                    <ButtonBlue
                      title={"Add File"}
                      bgColor={"bg-green hover:bg-green-600"}
                      onClick={() => handleFileUpload()}
                    />
                  )} */}
                  <div className="borderGray backGroundColor  p-4 rounded-2xl flex items-center w-full">
                    <ButtonCommonTopNew
                      className=" rounded-lg px-3 py-2 cursor-pointer items-center justify-center filter pointer text-sm w-max"
                      onClick={() => handleFileUpload()}
                    >
                      Browse
                    </ButtonCommonTopNew>
                    <span className="text-sm ml-3 blueColor">
                      Upload attachments
                    </span>
                  </div>
                  <input
                    className="hidden"
                    ref={uploaderRef}
                    type="file"
                    accept={attachmentExtension}
                    //accept="application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, ,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.slideshow,application/vnd.openxmlformats-officedocument.presentationml.presentation,.png"
                    multiple
                    onChange={(e) => addFiles(e)}
                  />
                </div>
                <div className="d-flex align-items-center py-2">
                  {files.length === 0 && (
                    <p className="text-center">
                      Please add all your files here before clicking on the
                      upload button.
                    </p>
                  )}
                </div>
                <div className="flex items-center w-full flex-wrap gap-2">
                  {files &&
                    files?.map((item, idx) => (
                      <>
                        <DivBadge
                          key={idx}
                          className="flex items-center rounded-lg px-3 justify-center w-max"
                        >
                          <span className="flex text-sm p-1 nav-navigate">
                            <div className=" text-white">{item.name}</div>
                          </span>
                          <div onClick={() => handleRemoveFile(idx)}>
                            <AiOutlineCloseCircle className="cursor-pointer text-white" />
                          </div>
                        </DivBadge>
                        {/* <div className="flex flex-row justify-between mb-2">
                          <div className="flex">
                            <div>
                              {idx + 1}
                              {". "}
                              {item.name}
                            </div>
                          </div>
                          <div
                            className="flex"
                            onClick={() => handleRemoveFile(idx)}
                          >
                            <AiOutlineCloseCircle className="cursor-pointer bg-removered" />
                          </div>
                        </div> */}
                      </>
                    ))}
                </div>
                <div className="w-full flex justify-center pt-2">
                  {/* {isDefaultTheme == false ? (
                    <ButtonCommon
                      className={"px-10 py-3"}
                      noCursor={files?.length > 0 ? false : true}
                      title={"Upload"}
                      onClick={handleAttachPost}
                    ></ButtonCommon>
                  ) : (
                    <ButtonBlue
                      noCursor={files?.length > 0 ? false : true}
                      bgColor={
                        files?.length > 0
                          ? "bg-green hover:bg-green-600"
                          : "bg-gray-400 hover:bg-gray-500"
                      }
                      title={"Upload"}
                      onClick={handleAttachPost}
                    />
                  )} */}
                  <ButtonCommonTopNew
                    className={`px-4 py-2 rounded-lg text-sm ${files?.length > 0
                        ? "cursor-pointer"
                        : "cursor-not-allowed"
                      } `}
                    onClick={files?.length > 0 ? handleAttachPost : () => { }}
                  >
                    Upload
                  </ButtonCommonTopNew>
                </div>
              </div>
            </>
          )}
        </Card>
      </section>
    </div>
  );
};

export default ModalRespondTask;
